<div class="flex flex-col items-center h-full my-10 px-5 md:px-12 lg:px-27">
    <form [formGroup]="loginForm" class="flex flex-col w-full sm:w-98 gap-4" (ngSubmit)="login()">
        <div class="flex items-center">
            <span class="h3-text text-text-primary text-center w-full" i18n>Log in</span>
        </div>
        <mat-form-field subscriptSizing="dynamic">
            <img matPrefix src="assets/icons/dark/mail.svg" class="prefix-icon" alt="email icon"/>
            <input matInput required 
                i18n-placeholder placeholder="Email" 
                type="text" formControlName="username"/>
        </mat-form-field>
        <mat-form-field subscriptSizing="dynamic">
            <img matPrefix src="assets/icons/dark/lock.svg" class="prefix-icon" alt="lock icon"/>
            <input matInput required i18n-placeholder placeholder="Password" type="{{ showPassword ? 'text' : 'password'}}" formControlName="password"/>
            <img matSuffix src="{{showPassword ? 'assets/icons/dark/eye-off.svg' : 'assets/icons/dark/eye.svg'}}" class="suffix-icon" alt="eye icon" (click)="togglePasswordVisibility()"/>
        </mat-form-field>
        <a routerLink="/profile/password/forgot" class="text-accent-blue body-s-text" i18n>Forgot password?</a>
        <mat-error class="text-center" *ngIf="loginForm.touched && 
            (loginForm.controls['username'].hasError('required') ||
            loginForm.controls['password'].hasError('required'))" i18n>Enter your email/password</mat-error>

        <button class="primary-button" color="accent" type="submit" i18n="@@log-in-action-button">Log in</button>
        <button class="base-button bg-white text-buttons-secondary flex justify-center items-center gap-2" type="button" (click)="signInWithGoogle()">
            <img src="assets/icons/google.svg" class="h-6 w-6" alt="google icon"/>
            <span i18n>Continue with Google</span>
        </button>
        <button class="secondary-button-transparent" type="button" routerLink="/register" i18n>Create account</button>
        
        <ng-container [ngSwitch]="errorStatusCode">
            <span class="collapse" *ngSwitchCase="0"></span>
            <p *ngSwitchCase="400" class="text-center text-red-500" i18n>Enter your email/password</p>
            <p *ngSwitchCase="401" class="text-center text-red-500" i18n>Incorrect email/password</p>
            <p *ngSwitchDefault class="text-center text-red-500" i18n>Oops, something went wrong</p>
        </ng-container>
    </form>
</div>